var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.breadcrumb
    ? _c("section", { staticClass: "el-section" }, [
        _c("nav", { staticClass: "emd-breadcrumb" }, [
          _c("ol", [
            _vm.breadcrumb.refer
              ? _c(
                  "li",
                  { staticClass: "emd-breadcrumb__item" },
                  [
                    _c("app-breadcrumb-item", {
                      attrs: { name: _vm.breadcrumb.refer },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.breadcrumb.parents
              ? _c(
                  "li",
                  { staticClass: "emd-breadcrumb__item" },
                  [
                    _c("app-breadcrumb-link", {
                      attrs: { items: _vm.breadcrumb.parents },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.breadcrumb.current
              ? _c(
                  "li",
                  { staticClass: "emd-breadcrumb__item _active" },
                  [
                    _c("app-breadcrumb-item", {
                      attrs: { name: _vm.breadcrumb.current },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }